<div class="flex h-full items-center" id="mobile-app-nav" [ngClass]="{ 'bg-primary-200': open() }">
	<div class="flex items-center cursor-pointer flex-col w-17" (click)="toggle()">
		<ui-icon icon="menu_bento" size="l" [type]="navColor()"></ui-icon>
		<div
			class="text-secondary-800 text-[0.625rem]"
			[ngClass]="{
				'text-secondary-800': navColor() === 'dark',
				'text-primary-700': navColor() === 'primary',
				'text-white': navColor() === 'light',
			}"
		>
			{{ navTranslations()?.apps }}
		</div>
	</div>

	@if (open()) {
		<div
			class="bg-standard shadow-around outline outline-1 -outline-offset-1 outline-secondary-200 fixed w-full left-0 right-0 bottom-14.5 rounded-t-3xl px-12 py-8"
		>
			<a
				[href]="myApp().url || '#'"
				[target]="myApp().newTab ? '_blank' : '_self'"
				class="flex items-center cursor-pointer mb-8 p-3"
				[style.background-color]="
					activeApp()?.name === myApp().name ? myApp().color?.background : ''
				"
			>
				<img alt="logo-my" class="h-16 w-52 block dark:hidden" [src]="myApp().image" />
				<img alt="logo-my" class="h-16 w-52 hidden dark:block" [src]="myApp().darkImage" />
			</a>
			<div class="mb-8">
				<ui-divider></ui-divider>
			</div>
			@for (app of _apps(); track app.name) {
				<a
					class="flex items-center cursor-pointer text-base gap-3 my-2 p-2"
					[href]="app.url || '#'"
					[target]="app.newTab ? '_blank' : '_self'"
					[style.background-color]="activeApp()?.name === app?.name ? app.color?.background : ''"
				>
					<img [alt]="'logo-' + app.name" [src]="app.imageSmall" class="h-16 max-h-6 w-auto" />
					<div>{{ app.translation }}</div>

					@if (app.beta) {
						<ui-tag [text]="navTranslations()?.beta || ''" type="dark"></ui-tag>
					}
				</a>
			}
		</div>
	}
</div>
